import { createApiRequest } from '../../store/api'

export const createBelaCintraLead = ({ onSuccess, onFail, data }) => {
  createApiRequest({
    method: 'post',
    url: 'https://bc.housi.com.br/api.php',
    onFail,
    onSuccess,
    data,
    baseUrl: '',
  })
}

export const createCorporateProposal = ({ data, onSuccess, onFail }) => {
  createApiRequest({
    method: 'post',
    url: 'https://corporate.onhousi.com/proposal',
    data,
    onSuccess,
    onFail,
    baseUrl: '',
  })
}

export const captureDecorLead = async ({ data }) => {
  return createApiRequest({
    method: 'post',
    url: 'https://captacao.onhousi.com/decor',
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
    data,
    baseUrl: '',
  })
}
export const captureEstimateLead = async ({ data }) => {
  return createApiRequest({
    method: 'post',
    url: 'https://captacao.onhousi.com/estimativa',
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
    data,
    baseUrl: '',
  })
}

export const captureIrentLead = ({ data, onSuccess, onFail }) => {
  createApiRequest({
    method: 'post',
    url: 'https://api-lp.housi.com.br/irent/api.php',
    data,
    onSuccess,
    onFail,
    baseUrl: '',
  })
}

export const capturePickupForm = ({ data, formName }) =>
  createApiRequest({
    method: 'post',
    url: `https://captacao.onhousi.com/${formName}`,
    data,
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
    baseUrl: '',
  })

export const captureNewsLetter = ({ data }) =>
  createApiRequest({
    method: 'post',
    url: `https://captacao.onhousi.com/newsletter`,
    data,
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
    baseUrl: '',
  })

export const captureFariaLimaLead = ({ data, onSuccess, onFail }) =>
  createApiRequest({
    method: 'post',
    url: `${process.env.REACT_APP_API_GATEWAY_URL}/contacts/landing-pages`,
    data,
    onSuccess,
    onFail,
    baseUrl: '',
  })
export const createRealEstateLead = ({ data, onSuccess, onFail }) =>
  createApiRequest({
    method: 'post',
    url: 'https://www.rdstation.com.br/api/1.2/conversions',
    data,
    onSuccess,
    onFail,
  })

export const captureConnect = async ({ data }) =>
  createApiRequest({
    method: 'post',
    url: `https://captacao.onhousi.com/connect`,
    data,
    baseUrl: '',
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
  })

export const captureHousiSales = async ({ data }) =>
  createApiRequest({
    method: 'post',
    url: 'https://captacao.onhousi.com/housi-vendas',
    baseUrl: '',
    data,
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
  })

export const captureHousiExperience = ({ data }) =>
  createApiRequest({
    method: 'post',
    url: 'https://captacao.onhousi.com/housi-experience',
    baseUrl: '',
    data,
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
  })

export const captureHousiMarketplace = ({ data }) =>
  createApiRequest({
    method: 'post',
    url: 'https://captacao.onhousi.com/housi-parceiros',
    baseUrl: '',
    data,
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
  })

export const captureHousiData = ({ data }) =>
  createApiRequest({
    method: 'post',
    url: 'https://captacao.onhousi.com/datahousi',
    baseUrl: '',
    data,
    params: {
      token: 's3SScKhQTUVhqTQHBEGW',
      appName: 'captacao',
    },
  })
